import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { IGmbAnalytics, IGMBReviews } from '../contracts/IAnalitycs';
import { IGmbLocation } from '../contracts/ILocation';
import { ISetAuthCodePayload } from '../reposiitories/IGmb.repository';
import { GMB_STATUS } from './gmb.service';

export interface IGmbService {
  getLocation(): Observable<{ status: GMB_STATUS; data: IGmbLocation }>;
  getAnalytics(customFiler: any): Observable<IGmbAnalytics>;
  getGMBReviews(customFiler: any): Observable<IGMBReviews>;
  setAuthCode(payload: ISetAuthCodePayload): Observable<IGmbLocation[]>;
  getAuthCode(accessToken: any, idToken: any): Observable<any>;
  setSelectedLocation(payload: IGmbLocation): Observable<IGmbLocation>;
}

export const GMB_SERVICE = new InjectionToken<IGmbService>('GMB_SERVICE');
